const swiper_CN_Locale = {
    'swiper.banner1Title':'智敬超声新时代',
    'swiper.banner1Title1':'',
    'swiper.banner1Conter1':'全栈式智能超声解决方案',
    'swiper.banner2Title':'融合·创新',
    'swiper.banner2Conter1':'深度覆盖生殖/产科',
    'swiper.banner2Conter2':'新生儿科/妇科/甲乳/心功能/浅表器官多个方向',
    'swiper.banner3Title':'自主研发核心算法',
    'swiper.banner3Title1':'',
    'swiper.banner3Conter1':'突破开源算法局限',
    'swiper.banner3Conter2':'国内最早将深度学习成果应用于超声影像智能化',
    'swiper.banner4Title':'全球战略布局',
    'swiper.banner4Conter1':'面向全球, 用AI拥抱超声未来'
}
export default swiper_CN_Locale
